import React from 'react'

function Refresh ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='16' height='16' viewBox='0 0 16 16'>
      <path d='M13.901 2.599c-1.463-1.597-3.565-2.599-5.901-2.599-4.418 0-8 3.582-8 8h1.5c0-3.59 2.91-6.5 6.5-6.5 1.922 0 3.649 0.835 4.839 2.161l-2.339 2.339h5.5v-5.5l-2.099 2.099z' />
      <path d='M14.5 8c0 3.59-2.91 6.5-6.5 6.5-1.922 0-3.649-0.835-4.839-2.161l2.339-2.339h-5.5v5.5l2.099-2.099c1.463 1.597 3.565 2.599 5.901 2.599 4.418 0 8-3.582 8-8h-1.5z' />
    </svg>
  )
}

Refresh.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Refresh
